export default __webpack_public_path__ + "static/media/sidebar-close-icon.38a96e82.svg";